import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IRouteRecommendation } from '../../../interfaces/route-recommendations/route-recommendation';

@Component({
  selector: 'task-divider',
  templateUrl: './task-divider.component.html',
  styleUrls: ['./task-divider.component.scss', './vertical-list-dots.scss'],
})
export class TaskDividerComponent {
  @Input() hasTaskSwitch: boolean;

  @Input() showMiles: number;

  @Input() showTime: string;

  @Input() hasCarryOver: boolean;

  @Input() milesLabel: string = 'miles';

  @Input() isLastItem: boolean;

  @Input() carryOverCount: number;

  @Input() taskSwitchCount: number;

  @Input() expandedView: boolean;

  @Input() carryOverDistance: number;

  @Output() expandedViewEvent = new EventEmitter<boolean>();

  hmsto2dp(showTime: string) {
    const hms = showTime;
    const a = hms.split(':');
    let returnString = '';
    let hrs = parseInt(a[0]);
    let mins = parseInt(a[1]);

    if (hrs > 0) {
      returnString += hrs + (hrs > 1 ? ' hrs ' : ' hr ');
    }

    returnString += mins + (mins > 1 ? ' mins' : ' min');

    return returnString;
  }
}
